const reg = /\s+/;
/**
 * 获取分割后的数组
 * @param {string} 原文本
 */
export function splitText(text: string) {
  if (!text) return [];
  return text.split(reg);
}

export function splitTextWithDot(text: string) {
  if (!text) return [];
  return text.split('.');
}
